export function isVisible(el) {
  return el.offsetWidth > 0 && el.offsetHeight > 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/isVisible.js
// module id = 46
// module chunks = 0